interface RiskModalProps {
  open: boolean;
  onClose: () => void;
  isFirstVisit?: boolean;
}

const riskItems = [
  {
    icon: 'ri-prohibited-line',
    color: '#FF3B30',
    title: '境内禁止虚拟货币交易',
    desc: '根据国家发改委、中国人民银行等部门联合通知，境内任何机构和个人均不得从事虚拟货币交易、炒作活动。',
  },
  {
    icon: 'ri-bank-line',
    color: '#FF3B30',
    title: '禁止境内发行RWA代币',
    desc: '境内机构或个人不得发行任何形式的RWA代币，不得向境内公众募资，违者将面临刑事追诉。',
  },
  {
    icon: 'ri-shield-check-line',
    color: '#FFB800',
    title: '香港合格投资者门槛',
    desc: '在香港合规框架下，RWA产品仅面向专业投资者（个人资产≥800万港元或机构资产≥800万港元）。',
  },
  {
    icon: 'ri-global-line',
    color: '#1A4BFF',
    title: '跨境资金流动限制',
    desc: '境内资金跨境参与香港RWA投资涉及外汇管制规定，须经合法渠道，不得绕开资本管制。',
  },
  {
    icon: 'ri-file-text-line',
    color: '#1A4BFF',
    title: '本站性质声明',
    desc: '本站（RWA99.cn）仅提供政策科普、行业知识与教育内容，不进行任何形式的募资、推介或代币交易撮合。',
  },
];

export default function RiskModal({ open, onClose, isFirstVisit = false }: RiskModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4"
      onClick={(e) => { if (!isFirstVisit && e.target === e.currentTarget) onClose(); }}
    >
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="bg-[#FF3B30] rounded-t-2xl px-6 py-5 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 flex items-center justify-center bg-white/20 rounded-full">
              <i className="ri-error-warning-fill text-white text-xl"></i>
            </div>
            <div>
              <h2 className="text-white font-bold text-lg leading-none">
                {isFirstVisit ? '访问前必读：合规声明' : '合规风险重要提示'}
              </h2>
              <p className="text-white/80 text-xs mt-0.5">
                {isFirstVisit ? '请仔细阅读并确认您已知悉以下内容，方可继续浏览' : '请在使用本站前仔细阅读'}
              </p>
            </div>
          </div>
          {!isFirstVisit && (
            <button onClick={onClose} className="w-8 h-8 flex items-center justify-center text-white/80 hover:text-white hover:bg-white/20 rounded-full transition-colors cursor-pointer">
              <i className="ri-close-line text-xl"></i>
            </button>
          )}
        </div>

        {/* First Visit Banner */}
        {isFirstVisit && (
          <div className="bg-amber-50 border-b border-amber-200 px-6 py-3 flex items-center gap-2">
            <i className="ri-information-line text-amber-600 text-base shrink-0"></i>
            <p className="text-xs text-amber-800 font-medium">
              本站为RWA合规科普门户，不募资、不推介、不交易。请阅读以下合规声明后，点击底部按钮确认方可继续。
            </p>
          </div>
        )}

        {/* Content */}
        <div className="px-6 py-6 space-y-4">
          {riskItems.map((item, i) => (
            <div key={i} className="flex gap-4 p-4 rounded-xl bg-gray-50 border border-gray-100">
              <div className="w-10 h-10 flex items-center justify-center rounded-full shrink-0" style={{ backgroundColor: item.color + '15' }}>
                <i className={`${item.icon} text-lg`} style={{ color: item.color }}></i>
              </div>
              <div>
                <h4 className="font-semibold text-gray-800 text-sm mb-1">{item.title}</h4>
                <p className="text-gray-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}

          <div className="bg-[#FFF8E6] border border-[#FFB800]/40 rounded-xl p-4 text-xs text-[#92610A] leading-relaxed">
            <strong>免责声明：</strong>本站（RWA99.cn）所有内容仅供学习参考，不构成任何投资建议或法律意见，不构成任何代币发行邀约。具体合规问题请咨询专业律师或持牌金融机构。
          </div>
        </div>

        <div className="px-6 pb-6">
          <button
            onClick={onClose}
            className={`w-full py-3 text-white font-semibold rounded-xl transition-colors cursor-pointer ${isFirstVisit ? 'bg-[#7C3AED] hover:bg-[#5B21B6]' : 'bg-[#7C3AED] hover:bg-[#5B21B6]'}`}
          >
            {isFirstVisit ? '✓ 我已阅读并知悉上述合规声明，继续浏览' : '我已了解，继续浏览'}
          </button>
          {isFirstVisit && (
            <p className="text-center text-xs text-gray-400 mt-2">
              点击上方按钮即表示您已知悉本站合规声明 · 本声明记录您的确认状态
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
